import {usePage} from "@inertiajs/vue3";
import {computed} from "vue";
import {User} from "@/types";

const page = usePage()
export const useCurrentUser = computed(() => page.props.user as User)
